<template>
  <form @submit.prevent="submit" autocomplete="off">
    <t-modal-section class="mb-3">
      <b-row>
        <b-col
          sm="12"
          md="12"
          :lg="
            modalData.toPolicy || modalData.isGlobal || modalData.isMSP
              ? '12'
              : '6'
          "
        >
          <b-form-group
            class="mb-3"
            :label="this.$t('Domain')"
            label-for="domain"
            :state="$validateState($v.form.domain)"
          >
            <b-form-input
              autofocus
              data-test-id="modal-domain-domain"
              :state="$validateState($v.form.domain)"
              id="domain"
              @blur="setValidationInput('domain', $event.target.value)"
              :placeholder="this.$t('For example, www.example.com')"
            />

            <template #invalid-feedback>
              <p
                v-if="
                  $v.form.domain.$dirty &&
                  $v.form.domain.required &&
                  !$v.form.domain.isQualifiedDomain
                "
              >
                {{
                  $t(
                    "Please specify domain or partial domain only URLs are not permitted."
                  )
                }}
              </p>
              <p v-if="!$v.form.domain.required">
                {{ $t("This is a required field.") }}
              </p>
            </template>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          v-if="!modalData.toPolicy && !modalData.isGlobal && !modalData.isMSP"
        >
          <span>Policy</span>
          <section class="dropDownMenuWrapper">
            <button
              :class="'dropDownMenuButton'"
              ref="menu"
              @click.stop.prevent="openDropdownPolicy()"
            >
              <span> {{ selectedPolicy.text }}</span>
            </button>

            <div class="iconWrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-chevron-expand"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                />
              </svg>
            </div>
            <section
              class="dropdownMenu"
              @scroll="scrollDropDown"
              infinite-scroll-disabled="busy"
              infinite-scroll-distance="limit"
              v-if="isOpenPolicy"
            >
              <div class="dropdownMenu__list">
                <div
                  class="item"
                  v-for="(policy, idx) in policiesList"
                  :key="idx"
                >
                  <div class="icon-wrap" v-if="policy.isSelected">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-check-lg"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                      />
                    </svg>
                  </div>

                  <button
                    :class="
                      policy.isSelected
                        ? 'isSelected'
                        : 'notSelect' && policy.disabled
                        ? 'disabled'
                        : ''
                    "
                    @click.prevent="changePolicy(policy.value)"
                  >
                    {{ policy.text }}
                  </button>
                </div>
              </div>

              <!-- <slot /> -->
            </section>
          </section>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <t-checkbox
            class="mt-2 mb-3"
            id="subdomains"
            data-test-id="modal-domain-subdomains"
            :label="this.$t('Include subdomains')"
            v-model="form.subdomains"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <t-checkbox
            data-test-id="modal-domain-log-results"
            class="mt-2 mb-3"
            id="log_requests"
            :label="this.$t('Log requests for reporting')"
            v-model="form.log_requests"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :label="$t('Comments (optional)')"
            label-for="comment"
            :state="$validateState($v.form.comment)"
          >
            <b-form-textarea
              data-test-id="modal-domain-comment"
              id="comment"
              @blur="setValidationInput('comment', $event.target.value)"
              rows="3"
              max-rows="6"
              :state="$validateState($v.form.comment)"
            ></b-form-textarea>
            <template #invalid-feedback>
              <p v-if="$v.form.comment.$dirty && !$v.form.comment.minLength">
                {{
                  $t("X must be at least X characters long.", {
                    field: $t("Comments"),
                    length: $v.form.comment.$params.minLength.min,
                  })
                }}
              </p>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
    </t-modal-section>
  </form>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

import TModalSection from "@/components/TModalSection";

export default {
  components: {
    TModalSection,
  },
  data() {
    return {
      fetching: false,
      policyOptions: [],
      isOpenPolicy: null,
      currentPage: null,
      previousScrollPosition: null,
      dataOptions: {
        results: 10,
        page: 1,
      },
      selectedPolicy: {
        isSelected: null,
        text: "Please select a policy",
      },
      form: {
        domain: "",
        policy: "default",
        subdomains: true,
        log_requests: true,
        comment: "",
      },
    };
  },
  validations: {
    form: {
      domain: {
        required,
        minLength: minLength(2),
      },
      comment: {
        minLength: minLength(5),
        maxLength: maxLength(250),
      },
      policy: {
        required: requiredIf(function () {
          return (
            !this.modalData.toPolicy &&
            !this.modalData.isGlobal &&
            !this.modalData.isMSP
          );
        }),
      },
      subdomains: {},
      log_requests: {},
    },
  },
  watch: {
    customerPolicies() {
      this.policyOptions = [
        ...this.customerPolicies.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    },
  },
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("customerPolicies", [
      "createCustomerPolicy",
      "fetchScrollCustomerPolicies",
    ]),
    ...mapActions("customerAllowList", ["createCustomerAllowListEntry"]),
    ...mapActions("customerBlockList", ["createCustomerBlockListEntry"]),
    ...mapActions("customerDomains", ["createCustomerDomainListEntry"]),
    ...mapActions("globalDomains", ["createGlobalDomainListEntry"]),
    ...mapActions("mspDomains", ["createMSPDomainListEntry"]),
    ...mapActions("globalAllowList", ["createGlobalAllowListEntry"]),
    ...mapActions("globalBlockList", ["createGlobalBlockListEntry"]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },

    openDropdownPolicy() {
      var _this = this;
      const closeListerner = (e) => {
        if (_this.catchOutsidePolicyClick(e, _this.$refs.menu))
          window.removeEventListener("click", closeListerner),
            (_this.isOpenPolicy = false);
      };
      window.addEventListener("click", closeListerner);
      this.isOpenPolicy = !this.isOpenPolicy;
    },
    catchOutsidePolicyClick(event, dropdown) {
      // When user clicks menu — do nothing
      if (dropdown == event.target) return false;

      // When user clicks outside of the menu — close the menu
      if (this.isOpenPolicy && dropdown != event.target) return true;
    },
    changePolicy(id) {
      this.$v.form.policy.$touch();

      let selectedPolicy = this.policiesList.filter(function (policy) {
        policy.isSelected = false;
        if (policy.value === id) {
          policy.isSelected = true;

          return policy;
        }
      });

      selectedPolicy[0].isSelected = true;
      this.selectedPolicy.text = selectedPolicy[0].text;
      this.isOpenPolicy = !this.isOpenPolicy;
      this.form.policy = selectedPolicy[0].value;
    },

    scrollDropDown(item) {
      const { target } = item;
      let currentScrollPosition = target.scrollTop + target.scrollHeight;

      if (currentScrollPosition > this.previousScrollPosition) {
        if (
          Math.ceil(target.scrollTop) >=
            target.scrollHeight - target.offsetHeight &&
          this.dataOptions.page > this.currentPage
        ) {
          try {
            this.fetchScrollCustomerPolicies({
              id: this.selectedUser.id,
              ...this.dataOptions,
            });
          } catch (e) {
            console.log("e", e);
          } finally {
            this.currentPage = this.dataOptions.page;
            this.dataOptions.page++;
          }
        }
      }
      this.previousScrollPosition = currentScrollPosition;
    },
    async submit() {
      this.$v.$touch();
      let response = {
        code: 0,
      };

      if (!this.$v.$invalid && !this.fetching) {
        /* istanbul ignore else */
        if (this.modalData.isGlobal) {
          if (this.modalData.type === "allow") {
            response = await this.createGlobalAllowListEntry({
              body: this.form,
            });
          }
          if (this.modalData.type === "block") {
            response = await this.createGlobalBlockListEntry({
              body: this.form,
            });
          }
        } else if (this.modalData.toPolicy) {
          response = await this.createCustomerDomainListEntry({
            id: this.selectedUser.id,
            policyId: this.modalData.policyId,
            action: this.modalData.type,
            body: this.form,
          });
        } else if (this.modalData.policies) {
          response = await this.createCustomerDomainListEntry({
            id: this.selectedUser.id,
            policyId: this.form.policy,
            action: this.modalData.type,
            body: this.form,
          });
        } else if (this.modalData.policies) {
          response = await this.createGlobalDomainListEntry({
            id: this.selectedUser.id,
            action: this.modalData.type,
            body: this.form,
          });
        } else if (this.modalData.isMSP) {
          response = await this.createMSPDomainListEntry({
            id: this.modalData.mspId,
            policyId: this.form.policy,
            action: this.modalData.type,
            body: this.form,
          });
        }
      }
      /* istanbul ignore else */
      if (response.code === 200) {
        this.displayToast({
          title: this.$t("Success"),
          message: "Updated",
          duration: 2000,
          variant: "success",
        });

        this.showModal(false);
      }
    },
  },
  computed: {
    ...mapGetters("modal", ["modalData"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("customerPolicies", ["customerPolicies"]),
    policiesList: {
      get() {
        return [
          {
            value: "default",
            text: this.$t("Default Policy"),
            isSelected: false,
          },
          ...this.customerPolicies.map((policy) => {
            return {
              value: policy.id,
              text: policy.name,
              isSelected: false,
            };
          }),
        ];
      },
      set() {},
    },
  },
  created() {
    this.userAction(this.submit);
    if (this.modalData.policies)
      this.policyOptions = [
        { value: "default", text: this.$t("Default Policy") },
        ...this.customerPolicies.map(({ id, name }) => {
          return { value: id, text: name };
        }),
      ];
  },
};
</script>
<style lang="scss" scoped>
.t-collapse {
  border-bottom: none;
}

.dropDownMenuWrapper {
  position: relative;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  border-radius: 0.25rem;
  background: white;
  border: 1px solid #ced4da;
  color: #495057;
  margin-bottom: 2rem;
  margin-top: 5px;
  z-index: 2;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;

  .dropDownMenuButton {
    border: none;
    font-size: inherit;
    background: none;
    outline: none;
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0 70px 0 15px;
    margin: 0;
    line-height: 1;
    width: 100%;
    height: 100%;
    z-index: 2;
    cursor: pointer;
  }

  .iconWrapper {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 1;
  }
  .dropdownMenu {
    position: absolute;
    top: 50%;
    width: 100%;
    min-width: 300px;
    height: auto;
    left: 0;
    max-height: 150px;

    border-radius: 8px;
    border: 1px solid #eee;
    box-shadow: 10px 10px 0 0 rgba(black, 0.03);
    background: white;
    padding: 10px 30px;
    animation: menu 0.3s ease forwards;
    overflow: scroll;

    &__list {
      position: relative;
      div {
        font-weight: normal;
        display: block;
        white-space: nowrap;
        min-height: 1.2em;
        position: relative;

        cursor: pointer;
        &:hover {
          font-weight: bolder;
        }
        button {
          width: 100%;
          text-align: left;
          display: flex;
        }
        .item {
          position: relative;
        }
        .icon-wrap {
          position: absolute;
          left: -20px;
          top: -1px;
        }
      }
      .disabled {
        opacity: 0.3;
        cursor: default;
        &:hover {
          font-weight: normal;
        }
      }
    }
    .isSelected {
      font-weight: 500;
    }
    .notSelect {
      background-color: transparent;
    }

    .option {
      width: 100%;
      border-bottom: 1px solid #eee;
      padding: 20px 0;
      cursor: pointer;
      position: relative;
      z-index: 2;

      &:last-child {
        border-bottom: 0;
      }

      * {
        color: inherit;
        text-decoration: none;
        background: none;
        border: 0;
        padding: 0;
        outline: none;
        cursor: pointer;
      }
    }

    .desc {
      opacity: 0.5;
      display: block;
      width: 100%;
      font-size: 14px;
      margin: 3px 0 0 0;
      cursor: default;
    }
  }

  @keyframes menu {
    from {
      transform: translate3d(0, 30px, 0);
    }
    to {
      transform: translate3d(0, 20px, 0);
    }
  }
}
</style>
